import styled from 'styled-components';

export const Thead = styled.thead`
  background: #f2f2f2;
`;

export const Td = styled.td`
  border: 1px solid #e3e3e3;
  text-align: center;
`;

export const Tr = styled.tr`
  border: 1px solid #e3e3e3;
`;

export const Th = styled.th`
  text-align: center;
  background: #4b286d;
  color: #fff;
  font-weight: 700;
`;

export const ServiceNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
